
import { updateAppConfig } from '#app'
import { defuFn } from '/builds/netzfabrik/apanel/backbone-api/app/node_modules/defu/dist/defu.mjs'

const inlineConfig = {
  "nuxt": {
    "buildId": "b67c298d-5b01-4361-878e-194a0b7c09c4"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}



export default /* #__PURE__ */ defuFn(inlineConfig)
